module.exports = __webpack_public_path__ + "img/salariunioni.99218db7.svg";